/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BulkUpdateEquipmentWorkerRequest } from './bulk-update-equipment-worker-request';
import { BulkUpdateEquipmentModeRequest } from './bulk-update-equipment-mode-request';
import { SearchEquipmentRequest } from './search-equipment-request';


export interface BulkUpdateEquipmentByFilterRequest { 
    filter?: SearchEquipmentRequest;
    mode?: BulkUpdateEquipmentModeRequest;
    workers?: Array<BulkUpdateEquipmentWorkerRequest> | null;
}

